/** Shared spring configs — Nordic refined (snappy, not bouncy) */
export const springSnappy = { type: 'spring', stiffness: 400, damping: 30 };
export const springGentle = { type: 'spring', stiffness: 300, damping: 28 };
export const springSheet = { type: 'spring', stiffness: 380, damping: 32 };

export const tweenFast = { duration: 0.2, ease: [0.22, 1, 0.36, 1] };
export const tweenNormal = { duration: 0.32, ease: [0.22, 1, 0.36, 1] };
